// extracted by mini-css-extract-plugin
export default {"plain":"DropMenu_plain__e16bC"};